import { render, staticRenderFns } from "./academe.vue?vue&type=template&id=7003567d&scoped=true"
import script from "./academe.vue?vue&type=script&lang=js"
export * from "./academe.vue?vue&type=script&lang=js"
import style0 from "./academe.vue?vue&type=style&index=0&id=7003567d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7003567d",
  null
  
)

export default component.exports